import { StackHeaderBackButton } from "./StackHeaderBackButton";
import { StackHeaderComponent } from "./StackHeaderComponent";
import { StackHeaderLeft } from "./StackHeaderLeft";
import { StackHeaderRight } from "./StackHeaderRight";
import { StackHeaderSearchBar } from "./StackHeaderSearchBar";
import { StackHeaderTitle } from "./StackHeaderTitle";
import { NAVIGATOR_CONFIG } from "../../headless/children";
import { StackScreen, appendScreenStackPropsToOptions, validateStackPresentation } from "./StackScreen";
import { BottomToolbarHost } from "./StackToolbarBottomHost";
import { StackToolbarBadge, StackToolbarButton, StackToolbarComponent, StackToolbarIcon, StackToolbarLabel, StackToolbarMenu, StackToolbarMenuAction, StackToolbarSearchBarSlot, StackToolbarSpacer, appendStackToolbarPropsToOptions } from "./StackToolbar";
var StackHeader = Object.assign(StackHeaderComponent, {
  [NAVIGATOR_CONFIG]: true,
  Left: StackHeaderLeft,
  Right: StackHeaderRight,
  BackButton: StackHeaderBackButton,
  Title: StackHeaderTitle,
  SearchBar: StackHeaderSearchBar
});
export {
  BottomToolbarHost,
  StackHeader,
  StackHeaderBackButton,
  StackHeaderComponent,
  StackHeaderLeft,
  StackHeaderRight,
  StackHeaderSearchBar,
  StackHeaderTitle,
  StackScreen,
  StackToolbarBadge,
  StackToolbarButton,
  StackToolbarComponent,
  StackToolbarIcon,
  StackToolbarLabel,
  StackToolbarMenu,
  StackToolbarMenuAction,
  StackToolbarSearchBarSlot,
  StackToolbarSpacer,
  appendScreenStackPropsToOptions,
  appendStackToolbarPropsToOptions,
  validateStackPresentation
};
//# sourceMappingURL=index.js.map
